import React, { useMemo } from 'react';
import { Box, ThemeProvider, useTheme } from '@mui/material';
import MarketplaceShell from './MarketplaceShell';
import marketplaceTheme from './marketplaceTheme';
import { InShellContext } from './shellContext';

/** Wraps a page in the new top navigation and skins any legacy MUI content to the marketplace look. */
const ShellPage: React.FC<{ children: React.ReactNode; fullWidth?: boolean }> = ({ children, fullWidth }) => {
  const outer = useTheme();
  const theme = useMemo(() => marketplaceTheme(outer), [outer]);
  return (
    <MarketplaceShell maxWidth={fullWidth ? 'full' : 1180}>
      <InShellContext.Provider value={true}><ThemeProvider theme={theme}>
        <Box sx={{ py: { xs: 1.5, md: 3 } }}>{children}</Box>
      </ThemeProvider></InShellContext.Provider>
    </MarketplaceShell>
  );
};

export default ShellPage;
